import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FileText } from 'lucide-react';
import AppHeader from '../components/AppHeader';
import { TERMS_FULL, LAST_UPDATED_EN, LAST_UPDATED_AR } from '../data/legalContent';
import './LegalPages.css';

/**
 * iter306 — Full Terms of Use page.
 * Public route. Bilingual (EN/AR). Mobile-first. RTL/LTR safe.
 */
export default function Terms() {
  const { i18n } = useTranslation();
  const isRTL = i18n.language?.startsWith('ar');
  const lang = isRTL ? 'ar' : 'en';
  const doc = TERMS_FULL[lang];
  const lastUpdated = isRTL ? LAST_UPDATED_AR : LAST_UPDATED_EN;

  return (
    <div className="legal-page" dir={isRTL ? 'rtl' : 'ltr'} data-testid="terms-page">
      <AppHeader title={doc.title} backFallback="/" testId="terms-header" />
      <div className="legal-container">
        <div className="legal-header">
          <div className="legal-icon-wrapper">
            <FileText size={32} />
          </div>
          <h1 className="legal-title" data-testid="terms-title">
            {doc.title}
          </h1>
          <p className="legal-subtitle" data-testid="terms-last-updated">
            {isRTL ? `آخر تحديث: ${lastUpdated}` : `Last updated: ${lastUpdated}`}
          </p>
          <p className="legal-intro">{doc.intro}</p>
        </div>

        <div className="legal-content" data-testid="terms-content">
          {doc.sections.map((s, i) => (
            <section className="legal-section" key={i} data-testid={`terms-section-${i + 1}`}>
              <h2>{s.h}</h2>
              <p>{s.p}</p>
            </section>
          ))}
        </div>

        <div className="legal-footer-links" data-testid="terms-footer-links">
          <Link to="/privacy-policy" data-testid="terms-link-privacy">
            {isRTL ? 'سياسة الخصوصية' : 'Privacy Policy'}
          </Link>
          <span aria-hidden="true"> · </span>
          <Link to="/delete-account" data-testid="terms-link-delete">
            {isRTL ? 'حذف الحساب' : 'Delete Account'}
          </Link>
        </div>
      </div>
    </div>
  );
}
